<img [defaultImage]="defaultImage" [lazyLoad]="src" [alt]="alt" [ngClass]="classes" [ngStyle]="styles" [id]="ids" loading="lazy">